import { useSyncExternalStore } from 'react';
import { Download, Share } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { canShareVideoFile } from '@/lib/videoDelivery';

/** 動画を渡すボタンの姿。経路ごとにラベルとアイコンが決まる */
export interface VideoSaveAction {
  /** 共有シートを開くのか、直接ダウンロードするのか */
  mode: 'share' | 'download';
  label: string;
  Icon: LucideIcon;
}

const SAVE_ACTIONS: Record<VideoSaveAction['mode'], VideoSaveAction> = {
  // 共有シートが保存先を決めるので「保存」だけでよい。
  // 下部バーは4ボタンを分け合うので、字数はアイコンが欠けない長さに収める
  share: { mode: 'share', label: '保存', Icon: Share },
  download: { mode: 'download', label: '動画DL', Icon: Download },
};

// 能力と入力手段は実行中に変わらないので購読は要らない
function subscribe(): () => void {
  return () => undefined;
}

function readAction(): VideoSaveAction {
  return canShareVideoFile() ? SAVE_ACTIONS.share : SAVE_ACTIONS.download;
}

/**
 * 動画を渡すボタンが取る姿を、ブラウザの能力から読む。
 *
 * ブラウザの外にある事実なので `useSyncExternalStore` で読む。
 * `matchMedia` や Web Share API の無い環境ではダウンロードになり、
 * 実際に押されたときの経路（`deliverVideo`）と食い違わない（ADR-0010）。
 */
export function useVideoSaveAction(): VideoSaveAction {
  return useSyncExternalStore(subscribe, readAction, () => SAVE_ACTIONS.download);
}
